import React from 'react';
import './Footer.scss';

const FooterComponent = () => {
    return (
        <section className='FooterComponent'>
            <p> &#169; STEPHANIE DOOLIN 2022</p>
            <p>ALL RIGHTS RESERVED</p>
            <a>PRIVACY POLICY</a>
        </section>
    );
};

export default FooterComponent;
